import i18next from 'i18next';
import {
  formatDate,
  parseDate,
  toISODateOnly,
} from '../../../../../utils/dateUtils';
import {
  EmployeeTurnoverRateReportPayload,
  useMyEmployeeTurnoverRateReportQuery,
} from '../../../__generated__/graphql';
import { Period } from './components/EmployeeTurnoverRatePeriodFilter';
import { FlairDateFormat } from '../../../../../atomic/atoms/FlairFormattedDate/types';

export const useMyEmployeeTurnoverRateReportData = (period: Period) => {
  const currentDate = new Date();
  const startDate = getStartDate(period, currentDate);

  const { data, error, loading } = useMyEmployeeTurnoverRateReportQuery({
    variables: {
      filter: {
        startDate: toISODateOnly(startDate),
        endDate: toISODateOnly(currentDate),
      },
    },
  });

  return {
    data,
    loading,
    error,
  };
};

export const prepareChartData = (data: EmployeeTurnoverRateReportPayload) => {
  const categories = data.monthlyResults.map((item) =>
    formatDate(
      parseDate(item.monthDate),
      i18next.t(`date.${FlairDateFormat.MonthNameShortYear}`),
    ),
  );

  const seriesData = data.monthlyResults.map((item) => item.turnoverRate);
  const overallTurnoverRate = data.overallTurnoverRate;

  return {
    categories,
    seriesData,
    overallTurnoverRate,
  };
};

const getStartDate = (period: Period, currentDate: Date) => {
  const firstDayOfCurrentMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );

  if (period === 'last6Months') {
    return new Date(
      firstDayOfCurrentMonth.setMonth(firstDayOfCurrentMonth.getMonth() - 5),
    );
  } else {
    return new Date(
      firstDayOfCurrentMonth.setMonth(firstDayOfCurrentMonth.getMonth() - 11),
    );
  }
};
